import { Component, Input, OnChanges }  from '@angular/core';
import { Observable } from 'rxjs';
import { IColors, IPostAction, Post }  from '../../definitions/';
import { ViewTypeService, IViewType } from '../../view-type.service';

@Component({
  selector: 'block-post-banner',
  templateUrl: './block-post-banner.component.html',
  host: {
    class: 'w100'
  }
})

export class BlockPostBannerComponent implements OnChanges {

  @Input() post:          Post;
  @Input() colors:        IColors = { primary: '' };

  alignment:              string = 'text-left';

  viewType$:              Observable<IViewType>;

  postClasses:            string[] = ['content-width', 'm-s-b', 'bg-lighter-grey'];
  contentClasses:         string[] = ['col-12', 'text-center'];
  resourceClasses:        string[] = ['col-4'];
  textClasses:            string[] = ['p-static', 'p-lr-15', 'p-tb-15'];
  actionClasses:          string[] = ['m-m-t', 'banner-image-action'];

  //actionStyles:           { [prop: string]: string } = {};

  constructor(private _viewType: ViewTypeService) {
    this.viewType$ = this._viewType.get();
  }

  ngOnChanges() {
    if (!this.post)
      return ;

    if (this.post.options && this.post.options.post_classes) {
      this.postClasses = this.post.options.post_classes;
    }

    if (this.post.options && this.post.options.resource_classes) {
      this.resourceClasses = this.post.options.resource_classes;
    }

    if (this.post.options && this.post.options.text_classes) {
      this.textClasses = this.post.options.text_classes;
    }

    if (this.post.options && this.post.options.action_classes) {
      this.actionClasses = this.post.options.action_classes;
    }

    if (this.post.options && this.post.options.content_classes) {
      this.contentClasses = this.post.options.content_classes;
    }

    //if (this.post.options && this.post.options.action_styles && this.colors) {
      //this.actionStyles = { 'background-color': this.colors.primary, ...this.post.options.action_styles };
    //}
    //else if (this.colors) {
      //this.actionStyles = { 'background-color': this.colors.primary };
    //}
  }
}
